import { i18nDispatcherOnlineDispatching } from 'models/i18n';

const enDispatcherOnlineDispatching: i18nDispatcherOnlineDispatching = {
  title: 'Online dispatching',
  balanceGroupImbalance: {
    title: 'Balance group imbalance',
    plannedImbalanceD1: 'Planned imbalance D+1',
    plannedImbalanceHX: 'Planned imbalance H+X',
    actualImbalance: 'Actual imbalance'
  },
  systemValues: {
    title: 'System values',
    system: 'system',
    price: 'price',
    predictedPriceIDM15: 'Predicted price IDM15',
    predictedPriceIDM60: 'Predicted price IDM60',
    predictedSystemImbalance: 'Predicted system imbalance',
    systemImbalance: 'Actual system imbalance',
    actualSystemImbalance: 'Actual system imbalance'
  },
  productionPlan: {
    title: 'Production plan',
    plannedProduction: 'Planned production',
    predictedProduction: 'Predicted production',
    actualProduction: 'Actual production'
  },
  overviewTable: {
    title: 'List of delivery points and devices ',
    periodText: ' market period',
    input: {
      Filter: 'Delivery Points',
      DeliveryPoints: 'Delivery Points',
      BalancingGroups: 'Balancing Groups'
    },
    columns: {
      deliveryPointName: 'Delivery point name',
      deviceName: 'Device name',
      communicationStatus: 'Communication status',
      actualProduction: 'Actual production',
      plannedProduction: 'Production plan',
      productionFulfillment: 'Production fulfilment',
      actions: 'Actions'
    }
  },
  deliveryPoint: {
    periodText: ' market period',
    systemValuesState: {
      heartbeat: 'Communication status',
      heartbeatLastUpdate: 'Last update',
      operationEvent: 'Operation',
      centreBreakDisconnectorStatus: 'Centre break disconnector status',
      fuseCarrierStatus: 'Fuse carrier status',
      outputBreakerStatus: 'Output breaker status',
      powerSwitchStatus: 'Power switch status',
      groundingStatus: 'Grounding status',
      hrmStatus: 'HRM status',
      activeEnergyTotalSupply: 'Active energy supply',
      activeEnergyTotalOfftake: 'Active energy offtake',
      sourceType: {
        FIELD: 'Field',
        DIST: 'Distributed station',
        DPOINT: 'Delivery point'
      }
    },
    operationEvents: { title: 'Operation events' },
    currentPhases: {
      title: 'Measured values',
      current: {
        title: 'Current',
        currentPhase1: 'Current phase IL1',
        currentPhase2: 'Current phase IL2',
        currentPhase3: 'Current phase IL3'
      },
      voltage: {
        title: 'Voltage',
        voltagePhase1: 'Voltage phase L1',
        voltagePhase2: 'Voltage phase L2',
        voltagePhase3: 'Voltage phase L3'
      },
      power: {
        title: 'Power',
        cosPhi: 'Power factor',
        frequency: 'Frequency',
        activePower: 'Active power'
      }
    }
  },
  device: {
    deviceParameters: {
      stateOfCharge: 'State of Charge',
      activeEnergySupply: 'Active supply energy',
      activeEnergyOfftake: 'Active offtake energy',
      phaseElementStatus: 'Phase element status',
      activeEnergyTotalSupply: 'Active total supply energy',
      activeEnergyTotalOfftake: 'Active total offtake energy',
      deviceControlMode: 'Device control mode',
      dcVoltage: 'Voltage',
      dcCurrent: 'Current',
      deviceEfficiency: 'Device efficiency',
      requestedPower: 'Requested power',
      activePower: 'Active power',
      reactivePower: 'Reactive power',
      tankFillLevel: 'Tank fill level',
      lowerWaterLevel: 'Lower water level',
      upperWaterLevel: 'Upper water level',
      turbineWaterFlow: 'Turbine water level',
      passiveWaterFlow: 'Passive water flow'
    },
    deviceControlMode: {
      max_power: 'Max power',
      requested_power: 'Requested power'
    },
    activeAndReactivePowerProgress: {
      title: 'Active and reactive power progress',
      activePower: 'Active power',
      reactivePower: 'Reactive power',
      activeRequestedPower: 'Active requested power'
    }
  }
};

export default enDispatcherOnlineDispatching;
